
export async function fetchData( zipCode ) {

  try {

    const response = await fetch( `https://bmx-apps.alextom.com/population-health-data/v2/stats-by-zip/${ zipCode }.json` )

    if ( ! response.ok ) {

      return { exists: false, ready: true }

    }

    const data = await response.json()

    return { ...data, exists: true, ready: true }

  } catch ( error ) {

    console.error( "Could not fetch the data:", error )

  }

}

export async function fetchNationalAverage() {

  try {

    const response = await fetch( 'https://bmx-apps.alextom.com/population-health-data/v2/national-average.json' )

    if ( ! response.ok ) {

      throw new Error( `HTTP error! status: ${ response.status }` )

    }

    const data = await response.json()

    return data

  } catch ( error ) {

    console.error( "Could not fetch the data:", error )

  }

}
